import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainLayoutComponent } from './components/main-layout/main-layout.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NavSideBarComponent } from './components/nav-side-bar/nav-side-bar.component';
import { RouterModule } from '@angular/router';
import { AlertModule } from '../alert/alert.module';
import { HeaderMngComponent } from './components/header-mng/header-mng.component';
import { MenuBarComponent } from './components/menu-bar/menu-bar.component';
import { FormsModule } from '@angular/forms';
import { StoreMenuListComponent } from './components/store-menu-list/store-menu-list.component';
import { MngMenuListComponent } from './components/mng-menu-list/mng-menu-list.component';
import { SharedModule } from '../shared/shared.module';
import { StoreInfoBarComponent } from './components/store-info-bar/store-info-bar.component';



@NgModule({
  declarations: [
    MainLayoutComponent,
    HeaderComponent,
    FooterComponent,
    NavSideBarComponent,
    HeaderMngComponent,
    MenuBarComponent,
    StoreMenuListComponent,
    MngMenuListComponent,
    StoreInfoBarComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    AlertModule,
    FormsModule,
    SharedModule
  ],
  exports:[
    MainLayoutComponent,
    HeaderComponent,
    FooterComponent,
    NavSideBarComponent
  ]
})
export class LayoutModule { }
